<template>
    <div id="app" class="home_page">
      <HeaderComponent />
        <CalculateComponent/>
        <FooterComponents/>
    </div>
  </template>
<script>
import FooterComponents from '@/components/FooterComponents.vue'
import HeaderComponent from '@/components/HeaderComponent'
import CalculateComponent from '@/components/CalculateComponent.vue'
export default {
  name: 'HomePage',
  data () {
    return {
    }
  },
  components: {
    HeaderComponent,
    FooterComponents,
    CalculateComponent
  },
  created () {
  },

  methods: {}
}

</script>
